export const AUDIENCES = [
  ["internal_recruiting", "Internal Staff"], ["group_admin", "Group Admin"], ["recruiting_manager", "Recruiting Manager"],
  ["internal_recruiter", "Recruiter"], ["agent", "Agents"], ["agent_staff", "Agent Staff"], ["candidate", "Candidates"],
];
export const audLabel = (k) => (AUDIENCES.find(([v]) => v === k) || [k, k])[1];

export function scopeText(d, groups = []) {
  if (d.scope_type === "system") return "ALL Groups";
  if (d.scope_type === "account") return "Organization";
  const ids = [...new Set([...(d.organization_ids || []), d.organization_id].filter(Boolean))];
  const names = ids.map((i) => groups.find((g) => g.id === i)?.name || d.organization_name).filter(Boolean);
  return names.length ? [...new Set(names)].join(", ") : "Group";
}

export function fileType(d) {
  const n = (d.original_filename || "").toLowerCase();
  const ext = n.includes(".") ? n.split(".").pop() : "";
  if (ext) return ext.toUpperCase();
  if (d.source_type === "link") return "LINK";
  if (d.source_type === "text") return "TEXT";
  return (d.mime_type || "").split("/").pop()?.toUpperCase() || "—";
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "2-digit" }) : "—");
export const fmtSize = (b) => (!b ? "—" : b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export async function sha256(file) {
  const buf = await file.arrayBuffer();
  const h = await crypto.subtle.digest("SHA-256", buf);
  return [...new Uint8Array(h)].map((x) => x.toString(16).padStart(2, "0")).join("");
}

export function availability(d) {
  if (d.kc_ai) return "AI + Help";
  if (d.kc_ask) return "How Can We Help";
  return "Stored Only";
}

export function folderPath(folders, id) {
  const out = [];
  let f = folders.find((x) => x.id === id);
  while (f) { out.unshift(f.name); f = folders.find((x) => x.id === f.parent_id); }
  return out.join(" / ");
}
